import { Col, Container, Row } from 'react-bootstrap';

import ArticlePreview from './Components/ArticlePreview';

import './Home.css';

const metadata = require('./Article/.metadata.json');

const articles = () => {
    const keys = Object.keys(metadata);
    let randomArticles: string[] = [Object.keys(metadata)[0]];

    while (randomArticles.length < 10) {
        let randomIndex = Math.floor(Math.random() * keys.length);
        if (!randomArticles.includes(keys[randomIndex])) randomArticles.push(keys[randomIndex]);
    }

    return randomArticles;
};

function Home() {
    return (
        <>
            <Container>
                {/* Banner */}
                <div className='p-4 mb-4 text-white bg-dark home-banner position-relative'>
                    <Col md={6} className='px-0'>
                        <div>
                        <h1 className='display-4 fst-italic'>Hello, World! This is 91d906h4's Blog.</h1>
                        <p className='lead my-3'>Hi! Welcome to my blog. This blog records my articles and works.<br />Hope you a great day!</p>
                        <p className='lead mb-0'><a href='about/' className='text-white fw-bold'>About...</a></p>
                        <a href='about/' className='stretched-link'> </a>
                        </div>
                    </Col>
                </div>

                {/* Article */}
                <Row>
                    <Col md={8}>
                        <ArticlePreview pageSlice={articles()} metadata={metadata} />
                    </Col>
                    <Col md={4}>
                        <div className='position-sticky d-none d-sm-block'>
                            <div className='p-4 mb-3 bg-light rounded'>
                                <h4 className='fst-italic home-article-title'>About</h4>
                                <p className='mb-0'>This is my personal blog. It records my recent works and some ideas. If you want, you can find my contact details on about page.</p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default Home;